import {categories} from "./tableModules/categories"
import {childOrganisations} from "./tableModules/childOrganisations"
import {contacts} from './tableModules/contacts'
import {forms} from './tableModules/forms'
import {fundingPrograms} from './tableModules/fundingPrograms'
import {loginProviders} from './tableModules/loginProviders'
import {mailTemplates} from './tableModules/mailTemplates'
import {mails} from './tableModules/mails'
import {organisationUsers} from "./tableModules/organisationUsers"
import {organisations} from "./tableModules/organisations"
import {paymentRuns} from "./tableModules/paymentRuns"
import {payments} from "./tableModules/payments"
import {processes} from './tableModules/processes'
import {roles} from "./tableModules/roles"
import {statusNotifications} from "./tableModules/statusNotifications"
import {statuses} from "./tableModules/statuses"
import {userOrganisations} from "./tableModules/userOrganisations"
import {users} from './tableModules/users'
import {usersFrontend} from './tableModules/usersFrontend'
import {yearInterviews} from "./tableModules/yearInterviews"
import {years} from "./tableModules/years"

export const tableModules: TableModules = {
    categories,
    childOrganisations,
    contacts,
    forms,
    fundingPrograms,
    loginProviders,
    mailTemplates,
    mails,
    organisationUsers,
    organisations,
    paymentRuns,
    payments,
    processes,
    processGroups: {
        ...processes,
        name: 'processGroups',
    },
    roles,
    statusNotifications,
    statuses,
    testUsers: {
        ...users,
        name: 'testUsers'
    } as TableModule,
    userOrganisations,
    users,
    usersFrontend,
    yearInterviews,
    years
}
